/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum VersioningType {
    None = 0,
    CustomHeader = 1,
    QueryString = 2,
    AcceptHeader = 3,
}
